import { request } from '../lib/http'

export function login (user) {
  return request({
    url: 'auth/login',
    method: 'post',
    data: user
  })
}

export function check () {
  return request({
    url: 'auth/check',
    method: 'get'
  })
}

export function logout () {
  return request({
    url: 'auth/logout',
    method: 'patch'
  })
}

export function recoverPassword (email) {
  return request({
    url: 'auth/recover-password',
    method: 'post',
    data: email
  })
}

export function updatePassword (data) {
  return request({
    url: `auth/update-password/${data.email}/${data.key}`,
    method: 'patch',
    data
  })
}